import React from "react";
import { graphql } from "gatsby"
import Head from "react-helmet";
import Markdown from "../../components/Markdown"

import style from "./index.module.css";

export default ({ data }) => {
  const content = data.page
  return (
    <div>
      <Head>
        <title>{content.title}</title>
      </Head>
      <div className={style.content}>
        <div className={style.text}>
          <h1>{content.title}</h1>
          {content.text.text &&
            <Markdown source={content.text.text} softBreak="br" className={style.richText} />
          }
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query {
    page: contentfulTekstpagina(contentful_id: {eq: "2J4ufcY9tSY2QUOWyuSOmE"}) {
      title
      metaDescription {metaDescription}
      text {text}
    }
  }
`